import Vue from 'vue'
import Router from 'vue-router'



Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/map',
      name: 'map',
      component: resolve=>require(['../components/Map.vue'],resolve),
    },
    {
      path: '/',
      name: 'sand',
      component: resolve=>require(['../components/Sand.vue'],resolve),
    },
//在这里设置初始进入的路由
/*    {
      path: '/',
      name: 'location',
      component: resolve=>require(['../components/Location.vue'],resolve),
    },*/
    {
      path: '/user',
      name: 'user',
      component: resolve=>require(['../components/User.vue'],resolve),
    },
    {
      path: '/brand',
      name: 'brand',
      component: resolve=>require(['../components/Brand.vue'],resolve),
    },
    {
      path: '/brand_JT',
      name: 'brand_JT',
      component: resolve=>require(['../components/Brand_JT.vue'],resolve),
    },
    {
      path: '/sand',
      name: 'sand',
      component: resolve=>require(['../components/Sand.vue'],resolve),
    },
    {
      path: '/location',
      name: 'location',
      component: resolve=>require(['../components/Location.vue'],resolve),
    },
    {
        path: '/childsand',
      name: 'childsand',
      component: resolve=>require(['../components/ChildSand.vue'],resolve),
    },
    {
      path: '/massif',
      name: 'massif',
      component: resolve=>require(['../components/Massif.vue'],resolve),
    },
    {
      path: '/distribution',
      name: 'distribution',
      component: resolve=>require(['../components/Distribution.vue'],resolve),
    },
    {
      path: '/roam',
      name: 'roam',
      component: resolve=>require(['../components/Roam.vue'],resolve),
    },
    {
      path: '/hardcover',
      name: 'hardcover',
      component: resolve=>require(['../components/Hardcover.vue'],resolve),
    },


/*    {
      path: '/childsand26',
      name: 'childsand26',
      component: resolve=>require(['../components/ChildSand26.vue'],resolve),
    },
    {
      path: '/distribution26',
      name: 'distribution26',
      component: resolve=>require(['../components/Distribution26.vue'],resolve),
    },
    {
      path: '/roam26',
      name: 'roam26',
      component: resolve=>require(['../components/Roam26.vue'],resolve),
    },
    {
      path: '/hardcover26',
      name: 'hardcover26',
      component: resolve=>require(['../components/Hardcover26.vue'],resolve),
    },
    {
      path: '/massif26',
      name: 'massif26',
      component: resolve=>require(['../components/Massif26.vue'],resolve),
    },
    {
      path: '/JG_DK',
      name: 'JG_DK',
      component: resolve=>require(['../components/JG_DK.vue'],resolve),
    },
    {
      path: '/JG_RK',
      name: 'JG_RK',
      component: resolve=>require(['../components/JG_RK.vue'],resolve),
    },*/
  ]
})






// WEBPACK FOOTER //
// ./src/router/index.js